module.exports = __webpack_public_path__ + "img/switch-on.c6ee9809.svg";